
import { IHttpHeadResponse } from "../http/IHttpHeadResponse";

export class AwsHttpRequest {
    
    static sendHeadRequest(url: string): Promise<IHttpHeadResponse> {
        return new Promise<IHttpHeadResponse>((resolve, reject) => {
            let request = AwsHttpRequest.createRequest('GET', url, reject);
            request.setRequestHeader("Range", `bytes=1-2`);
            request.onerror = (e) => {
                console.warn(e);
            }
            request.onload = () => {
                try {
                    let contentLength = 0;
                    let contentRange = request.getResponseHeader('Content-Range');
                    if (contentRange){
                        contentLength = parseInt(contentRange.slice(contentRange.indexOf('/') + 1), 10);
                    } else {
                        reject('Missing Content-Range header');
                        return;
                    }

                    if (isNaN(contentLength)){
                        reject('Invalid Content-Length: ' + contentLength);
                        return;
                    }
                    resolve({
                        contentLength: contentLength,
                        contentType: request.getResponseHeader('Content-Type')
                    });
                } catch (e){
                    reject('Unknown error: ' + e);
                }
            };
            request.send();
        });
    }

    static sendRangeRequest(url: string, start: number, end: number): Promise<ArrayBuffer> {
        return new Promise<ArrayBuffer>((resolve, reject) => {
            let request = AwsHttpRequest.createRequest('GET', url, reject);

            request.setRequestHeader("Range", `bytes=${start}-${end}`);
            request.setRequestHeader("Accept", `application/pdf`);
            request.onload = () => {
                resolve(request.response);
            };
            request.send();
        });
    }


    private static createRequest(verb: 'GET' | 'HEAD', url: string, rejectFn: (arg?: any) => void): XMLHttpRequest {

        let request = new XMLHttpRequest();
        request.open(verb, url , true);
        request.responseType = "arraybuffer";

        request.onerror = () => {
            rejectFn(request.status + ': ' + request.statusText);
        };

        request.onabort = () => {
            rejectFn(request.status + ': ' + request.statusText);
        };

        request.ontimeout = () => {
            rejectFn('TIMEOUT');
        };

        return request;
    }
}